import {useMemo} from 'react';

const useMyTenbisActions = () => {
  return useMemo(() => ([
    {
      key: 'link_credit_card',
      caption: 'link_credit_card_to_10bis',
      onClick: () => {},
    },
    {
      key: 'billing_permissions',
      caption: 'manage_billing_permissions',
      onClick: () => {},
    },
    {
      key: 'card_lost_or_stolen',
      caption: 'card_lost_or_stolen',
      onClick: () => {},
    },
    {
      key: 'card_worn_or_not_working',
      caption: 'card_worn_or_not_working',
      onClick: () => {},
    },
    {
      key: 'cancel_card',
      caption: 'cancel_10bis_card',
      onClick: () => {},
    },
  ]), []);
};

export default useMyTenbisActions;
